import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getAccessToken } from '../../../utils/auth';

const AuthenticatedRoute = () => {
  const token = getAccessToken();

  if (!token) {
    localStorage.clear();
    return <Navigate to='/login' />;
  }

  return <Outlet />;
};

export default AuthenticatedRoute;
